import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  Bar,
} from "recharts";

import { Typography } from "clearsense-ui/components";
import ContentBox from "components/Common/ContentBox";

const DataOccurrence = ({ chartData }) => (
  <div className="p-4">
    <ContentBox className="flex flex-col">
      <Typography style="h4" type="semibold" className="mb-2">
        Data Occurrence Summary
      </Typography>
      <div className="data_qa_dashboard__charts">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={chartData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            barSize={20}
          >
            <XAxis
              dataKey="name"
              scale="point"
              padding={{ left: 10, right: 10 }}
            />

            <YAxis
              label={{
                value: "Count",
                angle: -90,
                position: "left",
              }}
            />
            <Tooltip />
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar
              dataKey="count"
              name={chartData?.key}
              fill="#8884d8"
              background={{ fill: "#eee" }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </ContentBox>
  </div>
);

export default DataOccurrence;
